import { useState } from "react";
import { auth } from "../services/auth";
import { Link, useLocation } from "react-router-dom";

export function Login() {
  const [username, setUsername] = useState([]);
  const [password, setPassword] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const location = useLocation();

  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await auth(username, password).then((data) => {
        if (typeof data.message !== "undefined") {
          const regex = /(<([^>]+)>)/gi;
          const cleanErrorMessage = data.message.replace(regex, "");
          setErrorMessage(cleanErrorMessage);
        } else if (typeof data.token !== "undefined") {
          console.log("success");
          // Clear All Cookies to avoid login problems
          const cookies = document.cookie.split("; ");
          for (let c = 0; c < cookies.length; c++) {
              let d = window.location.hostname.split(".");
              while (d.length > 0) {
                  let cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
                  let p = window.location.pathname.split('/');
                  document.cookie = cookieBase + '/';
                  while (p.length > 0) {
                    document.cookie = cookieBase + p.join('/');
                    p.pop();
                  };
                  d.shift();
              }
          }
          // Obtén la ruta `redirect_to` de la URL actual
          const redirectTo = new URLSearchParams(location.search).get("redirect_to");
          window.location.replace(redirectTo || "/");
        } else {
          console.log("error");
          setErrorMessage(
            "Se ha producido un error. Vuelva a intentarlo de nuevo o contacte con el administrador."
          );
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div id='content' className='login-page'>
      <form onSubmit={handleLogin}>
        <div className='login-full'>
          <div className='login-bg'></div>
          <div className='login-content'>
            <div className='login-form'>
              <h3>Bienvenido a TAVAD</h3>
              <p className='login-copy'>Por favor, introduzca sus datos</p>
              <div className='login-input'>
                <div className='field'>
                  <label>Nombre de usuario o email</label>
                  <div className='control'>
                    <input
                      className='input'
                      required
                      type='text'
                      placeholder='Usuario o email'
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label>Contraseña</label>
                  <div className='control'>
                    <input
                      className='input'
                      required
                      type='password'
                      placeholder='Contraseña'
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                </div>
                <button className='button is-link' type='submit'>
                  Iniciar sesión
                </button>
              </div>
              <p className='login-copy'><Link to="/reset-password">¿Has olvidado tu contraseña?</Link></p>
              {errorMessage && <p className='login-error'>{errorMessage}</p>}
            </div>
            <div className='login-rights'>
              <p>© {getCurrentYear()} TAVAD</p>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}
